import { render, staticRenderFns } from "./DataContributorOnboardingStep2.vue?vue&type=template&id=54393cd2"
import script from "./DataContributorOnboardingStep2.vue?vue&type=script&lang=js"
export * from "./DataContributorOnboardingStep2.vue?vue&type=script&lang=js"
import style0 from "./DataContributorOnboardingStep2.vue?vue&type=style&index=0&id=54393cd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports